import React from 'react';
import { useRecoilState } from 'recoil';
import { useLocalSessionId, useParticipantProperty } from '@daily-co/daily-react';
import Tile from '../../Tile/Tile';
import './Teacher.css'
import { teacherIdState } from '../../../state/participantAtom';

export default function Teacher({ teacherScreen }) {
  const [teacherId] = useRecoilState(teacherIdState);
  const localSessionId = useLocalSessionId();
  const localUsername = useParticipantProperty(localSessionId, 'user_name');
  const isLocalUserTeacher = localUsername === 'Admin';

  return (
    <div className="teacher">
      {isLocalUserTeacher && !teacherScreen && <Tile id={localSessionId} isLocal isTeacher />}
      {teacherScreen && (
        <Tile key={teacherScreen.id} id={teacherScreen.session_id} isScreenShare />
      )}

      {!isLocalUserTeacher && teacherId && !teacherScreen && <Tile id={teacherId} isTeacher />}
      {!isLocalUserTeacher && !teacherId && (
        <div className="tile-video self-view alone" style={{ background: 'white' }}>
          <div style={{ width: '80vw' }} />
        </div>
      )}
    </div>
  )
}
